import { apiClient } from '@/lib/api-client';
import type { Protocol } from '@/types/api';

export const protocolApi = {
  /** One day's visits (YYYY-MM-DD), optionally one doctor's, by protocol number. */
  async day(params: { day: string; dentistId: string | null }) {
    const { data } = await apiClient.get<Protocol>('/protocol', {
      params: { day: params.day, dentistId: params.dentistId ?? undefined },
    });
    return data;
  },
};
